import { FileFragment } from 'models/api-response';
import { Box } from 'components/common';
import FileViewer from './FileViewer';
import { getFileUrl } from './helper';

export interface FileChartPanelProps {
  selectedFragment: FileFragment;
}

const FileChartPanel = (props: FileChartPanelProps) => {
  const chartData = props.selectedFragment?.chartData;
  const fileTitle = chartData?.fileTitle;
  const fileUrl = getFileUrl(chartData);

  return (
    <div className="file-chart">
      <Box mt3 mb>
        <h2>{fileTitle}</h2>
      </Box>
      <FileViewer key={fileUrl} fileUrl={fileUrl} fileTitle={fileTitle} />
    </div>
  );
};

FileChartPanel.displayName = 'FileChartPanel';
export default FileChartPanel;
